export default __webpack_public_path__ + "static/media/regulatory--fine-for-littering--g1.dfa21d74.png";